import React, { useEffect, useState } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  NavLink,
  Redirect,
  useLocation,
  useHistory,
} from 'react-router-dom';
import DashboardPage from '../pages/Dashboard/DashboardPage';
import LoginPage from '../pages/Login/LoginPage';
import LandingPage from '../pages/Landing/LandingPage'; // Import LandingPage
import PeringkatPriaPage from '../pages/Peringkat/PeringkatPriaPage';
import PeringkatWanitaPage from '../pages/Peringkat/PeringkatWanitaPage';
import { useAuth } from '../contexts/AuthContext';
import ForbiddenPage from '../pages/Errors/ForbiddenPage';
import ConfirmationModal from '../components/ConfirmationModal';

function AppRouterContent() {
  const { user, roles, phoneNumber, signOut, authLoading } = useAuth();
  const location = useLocation();
  const history = useHistory();
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);

  useEffect(() => {
    // Jika pengguna sudah login dan masih berada di halaman login,
    // arahkan ke dasbor.
    if (user && location.pathname === '/login') {
      history.replace('/dashboard');
    }
  }, [user, location.pathname, history]);

  if (authLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-brand-dark text-white">
        <p>Memuat...</p>
      </div>
    );
  }

  const handleLogout = () => {
    setShowLogoutConfirm(true);
  };

  const confirmLogout = () => {
    signOut();
    setShowLogoutConfirm(false);
  };

  const cancelLogout = () => {
    setShowLogoutConfirm(false);
  };

  return (
    <>
      {user && location.pathname !== '/' && (
        <nav className="bg-brand-dark text-white">
          <div className="container mx-auto flex flex-wrap items-center p-4">
            <div className="flex flex-wrap space-x-4 w-full md:w-auto">
              <NavLink to="/dashboard" activeClassName="font-bold text-brand-lime" className="hover:text-brand-lime transition-colors">
                Dasbor
              </NavLink>
            </div>
            <div className="flex items-center space-x-2 w-full mt-2 border-t border-gray-300 pt-2 md:mt-0 md:w-auto md:border-t-0 md:border-l md:pl-4 md:pt-0 md:ml-auto">
              <span className="text-sm text-gray-300">
                {phoneNumber}
                {roles && roles.length > 0 && ` (${roles.join(', ').toUpperCase()})`}
              </span>
              <button
                onClick={handleLogout}
                className="text-sm text-brand-terracotta hover:underline"
              >
                Keluar
              </button>
            </div>
          </div>
        </nav>
      )}
      <div className="container mx-auto p-4">
        <Switch>
          <Route exact path="/" component={LandingPage} />
          <Route path="/peringkat/pria" component={PeringkatPriaPage} />
          <Route path="/peringkat/wanita" component={PeringkatWanitaPage} />
          <Route
            path="/login"
            render={(props) =>
              !user ? <LoginPage {...props} /> : <Redirect to="/dashboard" />
            }
          />
          <PrivateRoute path="/dashboard" component={DashboardPage} />
          <Route path="/forbidden" component={ForbiddenPage} />
          <Redirect to={user ? '/dashboard' : '/'} />
        </Switch>
      </div>
      {showLogoutConfirm && (
        <ConfirmationModal
          message="Apakah Anda yakin ingin keluar?"
          onConfirm={confirmLogout}
          onCancel={cancelLogout}
        />
      )}
    </>
  );
}

export default function AppRouter() {
  return (
    <Router>
      <AppRouterContent />
    </Router>
  );
}

/**
 * A wrapper for <Route> that redirects to login if user is not authenticated.
 */
function PrivateRoute({ component: Component, ...rest }) {
  const { user } = useAuth();
  return (
    <Route
      {...rest}
      render={(props) =>
        user ? <Component {...props} /> : <Redirect to="/login" />
      }
    />
  );
}
